import { useRef, useState, type DragEvent } from "react";
import { ALLOWED_EXTENSIONS } from "@wedding/shared-types";
import { formatBytes } from "../../hooks/useUploadQueue.js";

const ACCEPT = ALLOWED_EXTENSIONS.map((ext) => `.${ext}`).join(",");

interface UploadDropzoneProps {
  onFiles: (files: FileList) => void;
  maxFileSizeBytes: number;
  maxFilesPerUpload: number;
}

export function UploadDropzone({ onFiles, maxFileSizeBytes, maxFilesPerUpload }: UploadDropzoneProps) {
  const inputRef = useRef<HTMLInputElement | null>(null);
  const [dragOver, setDragOver] = useState(false);

  function handleDrop(e: DragEvent<HTMLDivElement>) {
    e.preventDefault();
    setDragOver(false);
    if (e.dataTransfer.files.length > 0) onFiles(e.dataTransfer.files);
  }

  return (
    <div
      className="card"
      onDragOver={(e) => {
        e.preventDefault();
        setDragOver(true);
      }}
      onDragLeave={() => setDragOver(false)}
      onDrop={handleDrop}
      style={{
        textAlign: "center",
        borderStyle: "dashed",
        borderColor: dragOver ? "var(--color-primary)" : "var(--color-border)",
        borderWidth: 2,
      }}
    >
      <p>Glissez-déposez vos photos et vidéos ici, ou</p>
      <button type="button" className="btn btn-primary" onClick={() => inputRef.current?.click()}>
        Choisir des fichiers
      </button>
      <input
        ref={inputRef}
        type="file"
        multiple
        accept={ACCEPT}
        onChange={(e) => {
          if (e.target.files && e.target.files.length > 0) onFiles(e.target.files);
          e.target.value = "";
        }}
        style={{ display: "none" }}
      />
      <p style={{ marginTop: "var(--space-3)", fontSize: "0.85rem" }}>
        Photos (JPG, PNG, WEBP, HEIC) et vidéos (MP4, MOV, WEBM, M4V)
        <br />
        {formatBytes(maxFileSizeBytes)} max par fichier · {maxFilesPerUpload} fichiers à la fois maximum
      </p>
    </div>
  );
}
